import { type CombinedState, combineReducers, type Reducer } from "redux";
import DialogReducer, { type DialogState } from "./DialogReducer";
import UserReducer, { type UserState } from "./UserReducer";

export interface RootState {
    dialog: DialogState;
    user: UserState;
}

const DeveloperReducers = (): Reducer<CombinedState<RootState>> => combineReducers({
    dialog: DialogReducer,
    user  : UserReducer,
});

export default DeveloperReducers;
